import { Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { OnboardingChapterModule } from '@app/+onboarding/chapters/components/chapter.module';
import { SbFormFieldComponent } from '@app/shared/sb-lib/forms/sb-form-field.component';
import { TranslateModule } from '@ngx-translate/core';
import { MapMarker, MapPlace, MapsModule, MapsService } from '@sb/maps';
import { InputDirective } from '@sb/ui';
import { filter, take } from 'rxjs';

@Component({
  selector: 'time-tracking-clocking-location',
  standalone: true,
  imports: [
    OnboardingChapterModule,
    TranslateModule,
    SbFormFieldComponent,
    ReactiveFormsModule,
    InputDirective,
    MapsModule,
  ],
  templateUrl: './time-tracking-clocking-location.component.html',
})
export class TimeTrackingClockingLocationComponent implements OnInit {
  public selectedLocationMarker: MapMarker;

  @Input()
  public nextButtonLoading: boolean;

  @Input()
  public skipButtonLoading: boolean;

  @Output()
  public next = new EventEmitter<void>();

  @Output()
  public skip = new EventEmitter<void>();

  @Output()
  public locationChange = new EventEmitter<MapPlace>();

  @ViewChild('addressInput', { static: true })
  public addressInput!: ElementRef<HTMLInputElement>;

  public onNext() {
    if (this.selectedLocationMarker) {
      this.next.emit();
    }
  }

  public constructor(
    private ngZone: NgZone,
    private mapsService: MapsService,
  ) {}

  public ngOnInit() {
    void this.mapsService.apiLoaded$
      .pipe(
        filter((loaded) => loaded),
        take(1),
      )
      .subscribe(() => this.setupAutocomplete());
  }

  private setupAutocomplete() {
    const autocomplete = this.mapsService.getAutocomplete(this.addressInput.nativeElement);
    autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        const place = autocomplete.getPlace();

        if (!place?.geometry?.location) {
          return;
        }

        this.selectedLocationMarker = {
          id: place.name || 'main-location',
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };
        this.locationChange.emit(place);
      });
    });
  }
}
